export default __webpack_public_path__ + "static/media/plodeX@2x.b22f4164.png";